import {none, option, Option, some} from "ts-option";
import {BillOfMaterialsPreviewMerchant} from "./BillOfMaterialsPreviewDetails";
import JobProfit from "./JobProfit";
import Price from "../common/Price";
import {BillOFMaterialsPreviewApiDto} from "../../api/model/rest";
import {Bom} from "./Bom";

export class BillOfMaterialsPreview {
	constructor(
		public readonly bomId: Option<string>,
		public readonly incomplete: boolean,
		public readonly merchant: BillOfMaterialsPreviewMerchant,
		public readonly profit: JobProfit,
		public readonly total: Option<Price>
	) {}

	static fromJson(json: BillOFMaterialsPreviewApiDto) {
		const total = json.total ? some(Price.fromJson(json.total)) : none;
		return new BillOfMaterialsPreview(option(json.bomId), json.incomplete,
			BillOfMaterialsPreviewMerchant.fromJson(json.merchant), JobProfit.fromJson(json.profit), total)
	}

	fillFromBom(bom: Bom) {
		return this.copy({profit: bom.profit, total: bom.total})
	}

	copy({profit = this.profit, total = this.total, merchant = this.merchant}) {
		return new BillOfMaterialsPreview(this.bomId, this.incomplete, merchant, profit, total)
	}
}